export class ChatMessage {
  sender: string;
  message: string;
  timeSent: number;
  automated = false;
  senderParticipantId: string;
  /**
   * For AI assistant responses, the id of the underlying query. Used to submit
   * thumbs up/down feedback for that response.
   */
  queryId?: string;

  static fromPlainObject(obj: any): ChatMessage {
    return Object.assign(new ChatMessage(), obj) as ChatMessage;
  }
}

export type ChatType = 'team' | 'support';
